import { UTCDateFilterModule } from '@b2b/common/filters';
import { ContentHeaderProps, LooseAutocomplete, TODO, UIBModal, UIBModalService } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IDocumentService, IFilterService, IPromise, IQService, IScope, ITimeoutService } from 'angular';
import moment from 'moment-timezone';
import { TempDefinition, createDefinition, createQueryExpression } from '../types/definition.type';
import { ReportsCreateShowColumnsModalControllerModule } from './ReportsCreateShowColumnsModalController';
import { ReportsDatePickerControllerModule } from './ReportsDatePickerController';
import { PermissionsService } from '@b2b/common/services/permissions';

ReportsCreateController.$inject = [
  '$scope',
  '$state',
  '$q',
  '$filter',
  '$document',
  '$timeout',
  '$interval',
  '$uibModal',
  'ApiService',
  'CalendarService',
  'PermissionsService',
  'ReportsService',
  'HelpersService',
  'UserPreferencesService',
  'ThemesHelperService',
  'GridStateFactory',
];

function ReportsCreateController(
  $scope: IScope & { reportsCreate: TODO },
  $state: StateService,
  $q: IQService,
  $filter: IFilterService,
  $document: IDocumentService,
  $timeout: ITimeoutService,
  $interval: ITimeoutService,
  $uibModal: UIBModalService,
  ApiService: TODO,
  CalendarService: TODO,
  PermissionsService: PermissionsService,
  ReportsService: TODO,
  HelpersService: TODO,
  UserPreferencesService: TODO,
  ThemesHelperService: TODO,
  GridStateFactory: TODO
) {
  const ctrl = {
    groupMax: 8,
    queryLimit: 10,
    groupsModal: {} as UIBModal<TODO>,
    removeModal: {} as UIBModal<TODO>,
    showColumnsModal: {} as UIBModal<TODO>,
    showMessageModal: {} as UIBModal<TODO>,
    showMultiselectModal: {} as UIBModal<TODO>,
    timeModal: {} as UIBModal<TODO>,
    showFieldTypes: {},
    showGroupBy: false,
    fieldSelection: {},
    gridData: [] as TODO[],
    fieldNames: [] as TODO[],
    fieldValues: {},
    summaryFieldNames: [] as TODO[],
    dateFieldNames: [] as TODO[],
    numericFieldNames: [] as TODO[],
    fromDate: new Date(),
    fromTime: UserPreferencesService.dateFormats['hourFormat'] === 'HH:mm' ? '00:00' : '12:00 AM',
    fromDateTime: false,
    toDate: new Date(),
    toTime: UserPreferencesService.dateFormats['hourFormat'] === 'HH:mm' ? '23:59' : '11:59 PM',
    toDateTime: false,
    dateMode: 'range',
    dateField: null,
    nameEditMode: false,
    asyncReportRunning: false,
    reportRunning: false,
    reportSaving: false,
    previewInit: false,
    savedState: 'Saved',
    tempDefinition: {} as TempDefinition,
    dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),
    hourFormat: UserPreferencesService.getDateFormat('fieldDate', 'hourFormat'),
    dateTimeFormat: UserPreferencesService.getDateTimeFormat('sortDateTime'),
    model: {
      collection: {
        collectionName: '',
        analyticsFieldMetadataList: [] as TODO[],
      },
      definition: createDefinition(),
    },

    loading: true,

    lastAsyncReport: {
      id: null as number | null,
      lastUpdated: null as string | null,
    },

    ranges: CalendarService.ranges,
    searchQuery: '',
    grid: {
      pageSize: 50,
      showFooter: true,
      paginate: true,
      columnReordering: true,
      enableRowSelection: false,
      multiselect: false,
      columns: [] as TODO[],
    },

    typeahead: {
      pageSize: 20,
      totalServerItems: 0,
      isLoading: false,
      queryTimer: {},
      index: 0,
      items: [] as TODO[],
    },

    typeaheadItemDefinition: {
      input: '',
      selected: '',
      gridState: new GridStateFactory(),
      api: false,
      list: [] as TODO[],
      totalServerItems: 0,
      showMore: {
        showMoreLabel: '',
        hasMore: false,
      },
      isLoading: false,
    },

    init: function () {
      this.setContentHeader(true, false);
      ctrl.api.getDefinition($state.params.id);
      this.grid.pageSize = this.queryLimit;

      $scope.$on(
        '$destroy',
        $scope.$watch(
          'reportsCreate.model.definition.queryExpression.countFields',
          (n: TODO, o: TODO) => {
            if (n !== o) {
              ctrl.savedState = 'Unsaved';
            }
          },
          true
        )
      );

      $scope.$on(
        '$destroy',
        $scope.$watch(
          'reportsCreate.model.definition.queryExpression.summaryFields',
          (n: TODO, o: TODO) => {
            if (n !== o) {
              ctrl.savedState = 'Unsaved';
            }
          },
          true
        )
      );

      $scope.$on(
        '$destroy',
        $scope.$watch(
          'reportsCreate.model.definition.queryExpression.groupFields',
          (n: TODO, o: TODO) => {
            if (n !== o) {
              ctrl.savedState = 'Unsaved';
            }
          },
          true
        )
      );

      $scope.$on(
        '$destroy',
        $scope.$watch(
          'reportsCreate.model.definition.queryExpression.findQueries',
          (n: TODO, o: TODO) => {
            if (n !== o) {
              ctrl.savedState = 'Unsaved';
            }
          },
          true
        )
      );

      $scope.$on(
        '$destroy',
        $scope.$watch(
          'reportsCreate.selectedRange',
          (n: TODO, o: TODO) => {
            if (n && n !== o) {
              const range = n.logic(new Date());
              ctrl.fromDate = range.startDate;
              ctrl.toDate = range.endDate;
            }
          },
          true
        )
      );

      $scope.$on('DataGrid::sortChange', function (e, data) {
        if (data.field) {
          ctrl.model.definition.queryExpression.sortFields = [
            {
              fieldName: data.field,
              ascending: data.direction === 'asc',
            },
          ];
        }
      });

      $scope.$on('DataGrid::EventColumns', function (e, data) {
        if (data.originalPosition) {
          data.originalPosition = data.originalPosition - 1;
        }
        if (data.newPosition) {
          data.newPosition = data.newPosition - 1;
        }
        if (!ctrl.hasGroupFields()) {
          ctrl.gridActions.reorderColumns(data.col, data.originalPostion, data.newPosition);
        } else {
          ctrl.gridActions.reorderGroupedColumns(data.col, data.originalPostion, data.newPosition);
          if (ctrl.hasSummaryFields()) {
            ctrl.gridActions.reorderSummaryColumns(data.col, data.originalPostion, data.newPosition);
          }
        }
      });

      $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);

      $document.on('click', function (e) {
        if (ctrl.nameEditMode) {
          ctrl.nameEditMode = false;
          $scope.$apply();
          ctrl.actions.edit();
        }
      });
      $scope.$on('$destroy', function () {
        $document.off('click');
      });

      this.checkForLastAsyncReport();

      this.loading = false;
    },

    initRanges: function () {
      for (let i = 0, ii = this.ranges.length; i < ii; i++) {
        this.ranges[i].logic(new Date());
      }
      return this.ranges[0];
    },

    isDateMode: function (mode) {
      return this.dateMode === mode;
    },

    setDateMode: function (mode) {
      if (this.dateMode !== mode && this.selectedRange) {
        const range = this.selectedRange.logic(new Date());
        this.fromDate = range.startDate;
        this.toDate = range.endDate;
      }

      this.dateMode = mode;

      $timeout(function () {
        if (mode === 'range') {
          $('.report-date-range-field-select').focus();
        } else {
          $('#reports-from-date').focus();
        }
      }, 10);
    },

    getRangeForPreset: function (preset) {
      let result = false;

      if (preset) {
        for (let i = 0, ii = this.ranges.length; i < ii; i++) {
          if (this.ranges[i].type === preset) {
            result = this.ranges[i];
            break;
          }
        }
      }

      return result || this.ranges[0];
    },

    isGroupingBy: function (fieldName) {
      if (ctrl.model.definition.queryExpression.groupFields != null) {
        for (let i = 0; i < ctrl.model.definition.queryExpression.groupFields.length; i++) {
          if (fieldName === ctrl.model.definition.queryExpression.groupFields[i].fieldName) {
            return true;
          }
        }
      }
      return false;
    },

    getFilteredDate: function (date, fieldName) {
      if (!ctrl.isGroupingBy(fieldName)) {
        return $filter('date')(new Date(date), ctrl.dateTimeFormat).toLowerCase();
      } else {
        return date;
      }
    },

    getFromDateTime: function (toISO, fromDate, dataFromTime) {
      let isoFromTime;
      const fromTime = CalendarService.timeToDate(dataFromTime);
      const fromDateTime = new Date(
        fromDate.getFullYear(),
        fromDate.getMonth(),
        fromDate.getDate(),
        fromTime.getHours(),
        fromTime.getMinutes(),
        0,
        0
      );
      const targetTz = moment
        .tz(
          [fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate()],
          ThemesHelperService.getCompany('timezone')
        )
        .format('ZZ');

      if (toISO) {
        isoFromTime = CalendarService.toTZISO8601(
          new Date(
            fromDate.getFullYear(),
            fromDate.getMonth(),
            fromDate.getDate(),
            fromTime.getHours(),
            fromTime.getMinutes(),
            0,
            0
          ),
          targetTz
        );
      }

      return toISO ? isoFromTime : fromDateTime;
    },

    getToDateTime: function (toISO, toDate, dataToTime) {
      let isoToTime;
      const toTime = CalendarService.timeToDate(dataToTime);
      const toDateTime = new Date(
        toDate.getFullYear(),
        toDate.getMonth(),
        toDate.getDate(),
        toTime.getHours(),
        toTime.getMinutes(),
        59,
        999
      );
      const targetTz = moment
        .tz([toDate.getFullYear(), toDate.getMonth(), toDate.getDate()], ThemesHelperService.getCompany('timezone'))
        .format('ZZ');

      if (toISO) {
        isoToTime = CalendarService.toTZISO8601(
          new Date(
            toDate.getFullYear(),
            toDate.getMonth(),
            toDate.getDate(),
            toTime.getHours(),
            toTime.getMinutes(),
            59,
            999
          ),
          targetTz
        );
      }
      return toISO ? isoToTime : toDateTime;
    },

    showGroupFunctions: function (ndx) {
      let result = false;

      if (this.isDateField(this.model.definition.queryExpression.groupFields[ndx].fieldName)) {
        if (!this.model.definition.queryExpression.groupFields[ndx].groupFunction) {
          this.model.definition.queryExpression.groupFields[ndx].groupFunction = this.group.functions[0];
        }
        result = true;
      }

      return result; //ctrl.isDateField(ctrl.model.definition.queryExpression.groupFields[ndx].fieldName);
    },

    isArrayEmpty(values: unknown) {
      return Array.isArray(values) && values.length === 0;
    },

    hasColumns: function () {
      return !ctrl.isArrayEmpty(this.model.definition.queryExpression.findFields);
    },

    hasGroupFields: function () {
      return !ctrl.isArrayEmpty(this.model.definition.queryExpression.groupFields);
    },

    hasSummaryFields: function () {
      return !ctrl.isArrayEmpty(this.model.definition.queryExpression.summaryFields);
    },

    hasCountFields: function () {
      return !ctrl.isArrayEmpty(this.model.definition.queryExpression.countFields);
    },

    showRestrictButton: function () {
      return this.currentUserOwnsReport() || PermissionsService.check('REPORTS_RESTRICT_GROUPS');
    },

    currentUserOwnsReport: function () {
      return this.model.definition && this.model.definition.isCurrentUserReportOwner;
    },

    launchSelectTimeModal: function (data) {
      ctrl.timeModal = $uibModal.open({
        templateUrl: 'views/application/views/reports/create/modals/selectTime/selectTime.tpl.html',
        size: 'md',
        controller: 'ReportsCreateModalsSelectTimeController',
        backdrop: true,
        resolve: {
          fromTime: () => {
            return data ? data.fromTime : ctrl.fromTime;
          },
          toTime: () => {
            return data ? data.toTime : ctrl.toTime;
          },
          fromDate: () => {
            return data ? data.fromDate : ctrl.fromDate;
          },
          toDate: () => {
            return data ? data.toDate : ctrl.toDate;
          },
          isRange: () => {
            return true;
          },
        },
      });

      ctrl.timeModal.result.then(
        (result) => {
          if (data) {
            data.fromTime = result.fromTime;
            data.toTime = result.toTime;
            data.fromDate = result.fromDate;
            data.toDate = result.toDate;
            data.start = result.fromDateTime;
            data.end = result.toDateTime;
            data.fieldValue = [data.start].concat([data.end]).join();
          } else {
            ctrl.fromTime = result.fromTime;
            ctrl.toTime = result.toTime;
            ctrl.fromDate = result.fromDate;
            ctrl.toDate = result.toDate;
            ctrl.fromDateTime = result.fromDateTime;
            ctrl.toDateTime = result.toDateTime;
          }
        },
        () => {}
      );
    },

    launchGroupsModal: function () {
      ctrl.groupsModal = $uibModal.open({
        templateUrl: 'views/application/views/reports/create/modals/showUserGroups.tpl.html',
        size: 'md',
        controller: 'ReportsCreateShowGroupsModalController',
        backdrop: true,
        resolve: {
          CurrentUserGroups: () => {
            let result: TODO[] = [];
            if (Array.isArray(ctrl.model.definition && ctrl.model.definition.userGroups)) {
              result = ctrl.model.definition.userGroups;
            }
            return result;
          },
        },
      });

      ctrl.groupsModal.result.then(
        function (selectedGroups) {
          ctrl.model.definition.userGroups = selectedGroups;
        },
        function () {
          //do nothing
        }
      );
    },

    showColumns: function (init = false) {
      ctrl.showColumnsModal = $uibModal.open({
        templateUrl: 'views/application/views/reports/create/modals/showColumns.tpl.html',
        size: 'md',
        controller: 'ReportsCreateShowColumnsModalController',
        controllerAs: '$ctrl',
        backdrop: ctrl.hasColumns() ? true : 'static', // Only allow click away hiding if there are selected columns
        resolve: {
          currentColumns: () => {
            return ctrl.fieldsPanel.getFields();
          },
          save: () => {
            return init;
          },
        },
      });

      // Invoked when modal completes with close(params)
      ctrl.showColumnsModal.result.then(
        (selected) => {
          ctrl.fieldSelection = angular.copy(selected);

          for (const fieldName in selected) {
            if (selected.hasOwnProperty(fieldName)) {
              ctrl.fieldsPanel.toggleField({ name: fieldName }, true);
            }
          }

          if (!ctrl.model.definition.customReport) {
            if (init) {
              // Perform a save
              ctrl.actions.save();
              // Silent preview so no error is thrown
            }
          }
        },
        () => {}
      );
    },

    showMultiselect: function (filter) {
      ctrl.showMultiselectModal = $uibModal.open({
        templateUrl: 'views/application/views/reports/create/modals/showMultiselect.tpl.html',
        size: 'md',
        controller: 'ReportsCreateShowMultiselectModalController',
        resolve: {
          filter: () => {
            return filter;
          },
          currentValues: () => {
            return ctrl.fieldValues[filter.fieldName];
          },
        },
      });

      // Invoked when modal completes with close(params)
      ctrl.showMultiselectModal.result.then(
        function (selected) {
          filter.fieldValue = angular.copy(selected);
        },
        () => {}
      );
    },

    canPrint: function () {
      return this.gridData.length <= 2000 && this.gridData.length > 0;
    },

    isDateField: function (fieldName) {
      const count = ctrl.dateFieldNames.length;

      for (let i = 0; i < count; i++) {
        if (fieldName == ctrl.dateFieldNames[i].name) {
          return true;
        }
      }

      return false;
    },

    isNumericField: function (fieldName) {
      const count = ctrl.numericFieldNames.length;

      for (let i = 0; i < count; i++) {
        if (fieldName == ctrl.numericFieldNames[i].name) {
          return true;
        }
      }

      return false;
    },

    checkMaxGroupFields: function () {
      let result: TODO | false = false;

      if (Array.isArray(this.model.definition.queryExpression.groupFields)) {
        result = this.model.definition.queryExpression.groupFields.length >= this.groupMax;
      }

      return result;
    },

    checkForLastAsyncReport: function () {
      const query = { sortField: 'updatedOn', sortDirection: 'desc', page: 1, pageSize: 1 };

      ApiService.reporting.asyncReports.getByReportId($state.params.id, query).then(function (pagedReports) {
        const report = pagedReports.list[0];
        if (report) {
          ctrl.lastAsyncReport.id = report.id;
          ctrl.lastAsyncReport.lastUpdated = moment(report.updatedOn).fromNow();
        }
      });
    },

    processReport: function () {
      if (this.hasGroupFields()) {
        this.grid.enableColumnReorder = true;
        this.grid.enableSorting = false;
        this.fieldsPanel.clearFields();
        for (let i = 0, ii = this.model.definition.queryExpression.groupFields.length; i < ii; i++) {
          this.fieldsPanel.selectField({ name: this.model.definition.queryExpression.groupFields[i].fieldName });
        }
        if (this.hasSummaryFields()) {
          for (let i = 0, ii = this.model.definition.queryExpression.summaryFields.length; i < ii; i++) {
            this.fieldsPanel.selectField({
              name: this.model.definition.queryExpression.summaryFields[i].fieldName,
            });
          }
        }
        if (this.hasCountFields()) {
          for (let i = 0, ii = this.model.definition.queryExpression.countFields.length; i < ii; i++) {
            this.fieldsPanel.selectField({ name: this.model.definition.queryExpression.countFields[i].fieldName });
          }
        }
      } else {
        this.grid.enableColumnReorder = false;
        this.grid.enableSorting = true;
      }
    },

    setDateSettingSelections: function () {
      if (this.model.definition.dateSettings) {
        const dateSettings = this.model.definition.dateSettings;
        this.dateField = dateSettings.dateRangeField;

        if (dateSettings.datePreset && dateSettings.datePreset === 'custom') {
          this.selectedRange = this.getRangeForPreset(null);
          this.setDateMode('custom');
          this.fromDate = CalendarService.parseDate(dateSettings.startDate);
          this.toDate = CalendarService.parseDate(dateSettings.endDate);

          if (dateSettings.startDateTime) {
            this.fromDateTime = CalendarService.parseDate(dateSettings.startDateTime);
          } else {
            this.fromDateTime = this.getFromDateTime(null, this.fromDate, this.fromTime);
          }

          if (dateSettings.endDateTime) {
            this.toDateTime = CalendarService.parseDate(dateSettings.endDateTime);
          } else {
            this.toDateTime = this.getToDateTime(null, this.toDate, this.toTime);
          }

          this.fromTime = $filter('date')(
            this.fromDateTime,
            UserPreferencesService.getDateFormat('standardTime', 'hourFormat')
          );
          this.toTime = $filter('date')(
            this.toDateTime,
            UserPreferencesService.getDateFormat('standardTime', 'hourFormat')
          );
        } else {
          this.selectedRange = this.getRangeForPreset(dateSettings.datePreset);
          this.setDateMode('range');
        }
      }
    },

    marshallReportDefinition: function (type?: LooseAutocomplete<'copy'>) {
      const report = this.model.definition;

      report.dateSettings = {
        dateRangeField: this.dateField,
      };

      if (this.isDateMode('range')) {
        report.dateSettings.datePreset = this.selectedRange.type;
        report.dateSettings.startDate = null;
        report.dateSettings.endDate = null;
      } else {
        report.dateSettings.datePreset = 'custom';
        report.dateSettings.startDate = CalendarService.toISO8601(this.fromDate);
        report.dateSettings.endDate = CalendarService.toISO8601(this.toDate);
        report.dateSettings.startDateTime = this.getFromDateTime(true, this.fromDate, this.fromTime);
        report.dateSettings.endDateTime = this.getToDateTime(true, this.toDate, this.toTime);
      }

      if (report.userGroups) {
        //if userGroups is not an array with at least 1 item, remove userGroups.
        if (!Array.isArray(report.userGroups) || !report.userGroups.length) {
          delete report.userGroups;
        }
      }

      if (type === 'copy') {
        report.acmeDefault = false;
      }

      return report;
    },

    onDateFormatLoad: function (e, data) {
      ctrl.dateFormat = 'M!/d!/yyyy';
      ctrl.initRanges();
    },

    filterChanged: function (filter) {
      if (this.isDateField(filter.fieldName)) {
        if (filter.fromDate && filter.toDate) {
          const start = this.getFromDateTime(true, filter.fromDate, filter.fromTime);
          const end = this.getToDateTime(true, filter.toDate, filter.toTime);

          filter.fieldValue = [start].concat([end]).join();
        }
      } else if (this.isNumericField(filter.fieldName)) {
        if (filter.start !== undefined && filter.end !== undefined) {
          filter.fieldValue = [filter.start].concat([filter.end]).join();
        }
      }
    },

    setFindQueries: function () {
      if (ctrl.model.definition.queryExpression.findQueries) {
        const findQueries = ctrl.model.definition.queryExpression.findQueries.map(function (item) {
          if (ctrl.fieldsPanel.isTypeaheadField(item.fieldName)) {
            ctrl.setTypeahead(item);
          }

          if (
            ctrl.fieldsPanel.isBetweenOperator(item.operator) &&
            (ctrl.isDateField(item.fieldName) || ctrl.isNumericField(item.fieldName))
          ) {
            //set to and from times for filter
            ctrl.fieldsPanel.setBetweenFilter(item);
          }
          return item;
        });
      }
    },

    getItemAPI: function (item) {
      const q = $q.defer<TODO>();

      let result: IPromise<TODO> | false = false;

      switch (item.fieldName) {
        case 'EventTemplateName':
          result = ApiService.program.names(false, item.typeahead.gridState.getGridState());
          break;
      }

      if (result) {
        result
          .then((response) => {
            q.resolve(response);
          })
          .catch((response) => {
            q.reject(response);
          });
      }

      return q.promise;
    },

    processTypeahead: function (item, response) {
      const count = response.data.payload.pagination.count;
      const list = response.data.payload.list;
      const currentCount = (item.typeahead.gridState.gridState.page || 1) * item.typeahead.gridState.gridState.pageSize;

      item.typeahead.totalServerItems = count;
      item.typeahead.list = list;

      if (count && count > currentCount) {
        item.typeahead.showMore = {
          showMoreLabel: 'Show ' + ctrl.typeahead.pageSize + ' more of ' + count,
          hasMore: true,
        };
      } else {
        item.typeahead.showMore = {
          showMoreLabel: '',
          hasMore: false,
        };
      }
    },

    onSelectTypeahead: function (item, model, label, index) {
      this.model.definition.queryExpression.findQueries[index].fieldValue = label;
    },

    filterTypeahead: function (input, filter, force) {
      if (!angular.isObject(filter.typeahead.selected)) {
        filter.fieldValue = filter.typeahead.selected;
      } else {
        filter.fieldValue = filter.typeahead.selected.name;
      }

      filter.typeahead.input = input;

      if (this.typeahead.queryTimer) {
        $timeout.cancel(this.typeahead.queryTimer);
      }

      this.typeahead.queryTimer = $timeout(function () {
        if (!force) {
          filter.typeahead.gridState.setPropertyValue('pageSize', ctrl.typeahead.pageSize);
        } else {
          filter.typeahead.gridState.setPropertyValue(
            'pageSize',
            filter.typeahead.gridState.gridState.pageSize + ctrl.typeahead.pageSize
          );
        }

        filter.typeahead.gridState.gridState.search = filter.typeahead.selected || '';
        filter.typeahead.isLoading = true;

        ctrl.getItemAPI(filter).then(
          function (response) {
            ctrl.processTypeahead(filter, response);
            $scope.$broadcast('CustomTypeahead::FilterResults', { field: input });
            filter.typeahead.isLoading = false;
          },
          function (response) {}
        );
      }, 10);
    },

    showMoreResultsTypeahead: function (item, model, label, filter) {
      this.filterTypeahead(item.field, filter, true);
    },

    setTypeahead: function (item) {
      item.typeahead = angular.copy(ctrl.typeaheadItemDefinition);
      item.typeahead.selected = item.fieldValue;
      item.typeahead.gridState.updateGridState(null, ctrl.typeahead.pageSize, 'name', 'asc', '');
      item.typeahead.gridState.gridState.search = item.fieldValue || '';
      item.typeahead.isLoading = true;

      ctrl.getItemAPI(item).then(
        function (response) {
          ctrl.processTypeahead(item, response);
          item.typeahead.isLoading = false;
        },
        function (response) {}
      );
    },

    showAutoComplete: function (field) {
      const input = $('#reports-section-body-entry-typeahead-' + field);
      $timeout(function () {
        input.trigger('focus');
      }, 0);
    },

    api: {
      getDefinition: function (id) {
        ApiService.reporting.definitions.get(id).then(ctrl.success.getDefinition, ctrl.error.getDefinition);
      },

      getCollection: function (name: string) {
        ApiService.reporting.datasources.get(name).then(ctrl.success.getCollection, ctrl.error.getCollection);
      },
    },

    showReport: function (report) {
      ctrl.gridData = [];
      const cols = report.resultFieldList.length;

      if (cols === 0) {
        ctrl.actions.showMessage(
          'Sorry there was a problem',
          'No columns have been defined. Click Edit Columns and select columns to continue.'
        );

        return;
      }

      for (let rowIndex = 0; rowIndex < report.resultFieldList[0].values.length; rowIndex++) {
        const currentObj = {};

        for (let colIndex = 0; colIndex < ctrl.model.definition.queryExpression.findFields.length; colIndex++) {
          const currentCol = ctrl.model.definition.queryExpression.findFields[colIndex];
          currentObj[currentCol.fieldName] =
            report.resultFieldList[colIndex % report.resultFieldList.length].values[rowIndex];
        }

        ctrl.gridData.push(currentObj);
      }

      if (ctrl.gridData.length === 0 && !ctrl.previewInit) {
        const fromDate = $filter('date')(ctrl.fromDate, ctrl.dateFormat);
        const toDate = $filter('date')(ctrl.toDate, ctrl.dateFormat);

        ctrl.actions.showMessage(
          'Sorry there was a problem',
          `No data found for between ${fromDate} ${ctrl.fromTime} and ${toDate} ${ctrl.toTime}. Verify the date range is correct.`
        );
      } else if (ctrl.previewInit) {
        ctrl.previewInit = false;
      }

      if (ctrl.gridData.length > 0) {
        $timeout(() => {
          $('.ui-grid-cell-contents:first').focus();
        }, 10);
      }
    },

    setContentHeader: function (showLeftButton, showRightButton) {
      const content: ContentHeaderProps = { title: 'Reports' };

      if (showLeftButton) {
        content.buttonLeft = {
          label: 'Cancel',
          action: function () {
            window.history.go(-1);
          },
        };
      }
      if (showRightButton) {
        content.buttonRight = {
          label: 'Save & Close',
          permissions: ['REPORTS_UPDATE'],
          action: function () {
            ctrl.actions.close();
          },
        };
      }
      $scope.$emit('Application::contentTitleChange', content);
    },

    success: {
      getDefinition: function (response) {
        ctrl.tempDefinition = response.data.payload;
        ctrl.api.getCollection(ctrl.tempDefinition.displayCollectionName);
      },
      getCollection: function (response) {
        ctrl.model.collection = response.data.payload;
        ReportsService.metaFields = response.data.payload.analyticsFieldMetadataList;
        //next tick
        $timeout(function () {
          ctrl.model.definition = createDefinition({
            ...ctrl.tempDefinition,
            queryExpression: createQueryExpression(ctrl.tempDefinition.queryExpression),
          });

          ctrl.setContentHeader(true, !ctrl.model.definition.acmeDefault);

          if (ctrl.model.definition && !Array.isArray(ctrl.model.definition.userGroups)) {
            ctrl.model.definition.userGroups = [];
          }
          ctrl.fieldsPanel.setFieldSelections();
          ctrl.setDateSettingSelections();
          ctrl.setFindQueries();
        }, 0);
      },
      close: function () {
        $state.go('application.reports.list');
      },

      edit: function () {
        ctrl.reportSaving = false;
        ctrl.savedState = 'Saved';
      },

      report: function (response) {
        ctrl.reportRunning = false;
        ctrl.showReport(response.data.payload);
      },

      asyncReportGet: function (report) {
        const jsonResult = JSON.parse(report);
        ctrl.asyncReportRunning = false;
        ctrl.showReport(jsonResult);
        ctrl.checkForLastAsyncReport();
      },

      asyncReportCreate: function (asyncReport) {
        let hasRequestedStatus = false;
        const checkWaitDuration = 2000;
        const asyncCheck = $interval(checkLatestAsyncReport, checkWaitDuration);

        function checkLatestAsyncReport() {
          // Make sure we're not already waiting for an existing request
          if (!hasRequestedStatus) {
            hasRequestedStatus = true;

            ApiService.reporting.asyncReports
              .get(asyncReport.id)
              .then(ApiService.reporting.asyncReports.isReportCompleted)
              .then(isReportComplete, reportCheckFailure);
          }
        }

        function isReportComplete(isCompleted) {
          if (isCompleted) {
            $interval.cancel(asyncCheck);
            ctrl.actions.getAsyncReport(asyncReport.id);
          } else {
            hasRequestedStatus = false; // Not completed, so continue checking
          }
        }

        function reportCheckFailure(response) {
          $interval.cancel(asyncCheck);
          ctrl.error.asyncReport(response);
        }

        $scope.$on('$destroy', function () {
          $interval.cancel(asyncCheck);
        });
      },

      onSaveBeforeCopy: function (response) {
        ApiService.reporting.definitions
          .duplicate(ctrl.model.definition.id)
          .then(ctrl.success.onCopyComplete, ctrl.error.onCopyComplete);
      },
      remove: function (response) {
        $state.go('application.reports.list');
      },
      onCopyComplete: function (response) {
        const id = response.data.payload.id;
        ctrl.loading = false;
        $state.go('application.reports.create', { id: id });
      },
      onReport: function (response) {
        ApiService.reporting.reports
          .execute({
            reportDefinitionId: ctrl.model.definition.id,
            endDate: ctrl.toDate,
            startDate: ctrl.fromDate,
            endDateTime: ctrl.getToDateTime(true, ctrl.toDate, ctrl.toTime),
            startDateTime: ctrl.getFromDateTime(true, ctrl.fromDate, ctrl.fromTime),
            dateRangeField: ctrl.dateField,
          })
          .then(ctrl.success.report, ctrl.error.report);
      },
    },

    error: {
      getDefinition: function (response) {},
      getCollection: function (response) {},
      close: function (response) {},
      edit: function (response) {
        const message = response.data.error ? response.data.error : 'An unknown error has occurred';
        ctrl.reportSaving = false;
        ctrl.actions.showMessage('Error', message);
      },
      report: function (response) {
        const message = response.data.error ? response.data.error : 'An unknown error has occurred';
        ctrl.reportRunning = false;
        ctrl.actions.showMessage('Error', message);
      },
      asyncReport: function (response) {
        const message = response.data && response.data.error ? response.data.error : 'An unknown error has occurred';
        ctrl.asyncReportRunning = false;
        ctrl.actions.showMessage('Error', message);
      },
      onSaveBeforeCopy: function (response) {
        ctrl.loading = false;
      },
      remove: function (response) {},
      onCopyComplete: function (response) {
        ctrl.loading = false;
      },
      onReport: function (response) {
        ctrl.reportRunning = false;
      },
    },

    onColumnReordered: function (col, originalPosition, newPosition) {
      if (originalPosition) {
        originalPosition = originalPosition - 1;
      }
      if (newPosition) {
        newPosition = newPosition - 1;
      }
      if (!ctrl.hasGroupFields()) {
        ctrl.gridActions.reorderColumns(col, originalPosition, newPosition);
      } else {
        ctrl.gridActions.reorderGroupedColumns(col, originalPosition, newPosition);
        if (ctrl.hasSummaryFields()) {
          ctrl.gridActions.reorderSummaryColumns(col, originalPosition, newPosition);
        }
      }
    },

    actions: {
      close: function () {
        // Don't save if this is a custom report
        if (ctrl.model.definition.customReport) {
          ctrl.success.close();
        } else {
          ApiService.reporting.definitions
            .update(ctrl.marshallReportDefinition())
            .then(ctrl.success.close, ctrl.error.close);
        }
      },

      edit: function () {
        // Used when editing name
        ctrl.reportSaving = true;
        ApiService.reporting.definitions
          .update(ctrl.marshallReportDefinition())
          .then(ctrl.success.edit, ctrl.error.edit);
      },

      save: function () {
        ctrl.reportSaving = true;
        ApiService.reporting.definitions
          .update(ctrl.marshallReportDefinition())
          .then(() => {
            ctrl.reportSaving = false;
            ctrl.savedState = 'Saved';
            ctrl.actions.showSavedModal();
          })
          .catch((response) => {
            const message = response.data.error ? response.data.error : 'An unknown error has occurred';
            ctrl.reportSaving = false;
            ctrl.actions.showMessage('Error', message);
          });
      },

      copy: function () {
        ctrl.loading = true;

        if (ctrl.model.definition.acmeDefault) {
          /* no need to save the current copy if acmeDefautl is set to true */
          /* get the list of existing names and come up with a name for the new file. */
          ApiService.reporting.definitions
            .duplicate(ctrl.model.definition.id)
            .then(ctrl.success.onCopyComplete, ctrl.error.onCopyComplete);
        } else {
          /* save the current */
          /* make a copy */
          /* redirect to the new one */
          ApiService.reporting.definitions
            .update(ctrl.marshallReportDefinition())
            .then(ctrl.success.onSaveBeforeCopy, ctrl.error.onSaveBeforeCopy);
        }
      },
      remove: function () {
        ctrl.removeModal = $uibModal.open({
          templateUrl: 'views/application/views/reports/modals/removeReport.tpl.html',
          size: 'md',
          controller: 'ReportsRemoveModalController',
          resolve: {
            currentReport: () => {
              return ctrl.model.definition;
            },
          },
        });

        // Invoked when modal completes with close(params)
        ctrl.removeModal.result.then(
          () => {
            ApiService.reporting.definitions
              .remove(ctrl.model.definition.id)
              .then(ctrl.success.remove, ctrl.error.remove);
          },
          () => {}
        );
      },

      preview: function (init) {
        ctrl.processReport();

        const data = {
          reportDefinitionId: ctrl.model.definition.id,
          endDate: ctrl.toDate,
          startDate: ctrl.fromDate,
          endDateTime: ctrl.getToDateTime(true, ctrl.toDate, ctrl.toTime),
          startDateTime: ctrl.getFromDateTime(true, ctrl.fromDate, ctrl.fromTime),
          dateRangeField: ctrl.dateField,
          queryExpression: ctrl.model.definition.queryExpression,
        };

        // Remove sort fields if no groupFields exist
        /* Run preview report */
        ctrl.reportRunning = true;
        ctrl.queryLimit = 10;
        data.queryExpression.limit = ctrl.queryLimit;
        ctrl.previewInit = init;

        ApiService.reporting.reports.query(data).then(ctrl.success.report, ctrl.error.report);
      },

      createAsyncReport: function () {
        ctrl.processReport();

        const data = {
          reportUuid: ctrl.model.definition.id,
          endDate: ctrl.toDate,
          startDate: ctrl.fromDate,
          endDateTime: ctrl.getToDateTime(true, ctrl.toDate, ctrl.toTime),
          startDateTime: ctrl.getFromDateTime(true, ctrl.fromDate, ctrl.fromTime),
          dateRangeField: ctrl.dateField,
          queryExpression: ctrl.model.definition.queryExpression,
        };

        /* Run full report */
        ctrl.asyncReportRunning = true;
        ctrl.grid.pageSize = 50;
        ctrl.queryLimit = 0;
        data.queryExpression.limit = ctrl.queryLimit;

        ApiService.reporting.asyncReports.create(data).then(ctrl.success.asyncReportCreate, ctrl.error.asyncReport);
      },

      getAsyncReport: function (id) {
        ApiService.reporting.asyncReports.getJson(id).then(ctrl.success.asyncReportGet, ctrl.error.asyncReport);
      },

      downloadCsv: function (useQuery) {
        let form;
        let q = '';
        const query: TODO[] = [];
        const reportDateRange: TODO[] = [];
        const limit = ctrl.model.definition.queryExpression.limit;

        if (ctrl.model.definition.id) {
          query.push('reportDefinitionId=' + ctrl.model.definition.id);
        }

        if (ctrl.fromDate) {
          reportDateRange.push(CalendarService.toISO8601(ctrl.fromDate).split('T')[0]);
          query.push('startDate=' + CalendarService.toISO8601(ctrl.fromDate).split('T')[0]);
        }

        if (ctrl.toDate) {
          reportDateRange.push(CalendarService.toISO8601(ctrl.toDate).split('T')[0]);
          query.push('endDate=' + CalendarService.toISO8601(ctrl.toDate).split('T')[0]);
        }

        if (ctrl.fromDateTime) {
          query.push('startDateTime=' + ctrl.getFromDateTime(true, ctrl.fromDate, ctrl.fromTime));
        }

        if (ctrl.toDateTime) {
          query.push('endDateTime=' + ctrl.getToDateTime(true, ctrl.toDate, ctrl.toTime));
        }

        if (ctrl.dateField) {
          query.push('dateRangeField=' + ctrl.dateField);
        }

        if (query.length > 0) {
          q = '?' + query.join('&');
        }

        if (useQuery) {
          // Always download full report
          ctrl.model.definition.queryExpression.limit = 0;
          form = $('<form></form>')
            .attr('method', 'post')
            .attr('enctype', 'application/x-www-form-urlencoded')
            .attr(
              'action',
              '/v1/api/analytics/report/csv/execute/' +
                encodeURIComponent(ctrl.model.definition.name.replace(/[\s\W]+/g, '-')) +
                q
            );
          form.append(
            $('<input />')
              .attr('type', 'hidden')
              .attr('name', 'queryExpression')
              .attr('value', angular.toJson(ctrl.model.definition.queryExpression))
          );
          form.appendTo('body').submit().remove();
          ctrl.model.definition.queryExpression.limit = limit;
        } else {
          if (ctrl.lastAsyncReport && ctrl.lastAsyncReport.id) {
            (window as any).location = '/v2/api/async/report/csv/' + ctrl.lastAsyncReport.id;
          }
        }
      },

      launchPrint: function () {
        let message = '';

        if (!ctrl.hasColumns()) {
          message = 'Report has no columns selected. You must select columns to continue printing.';
        }

        if (message) {
          ctrl.actions.showMessage('Sorry there was a problem', message);
        } else {
          // Open print window
          HelpersService.setCookie('report', {
            endDate: ctrl.toDate ? CalendarService.toISO8601(ctrl.toDate).split('T')[0] : '',
            startDate: ctrl.fromDate ? CalendarService.toISO8601(ctrl.fromDate).split('T')[0] : '',
            endDateTime: ctrl.getToDateTime(true, ctrl.toDate, ctrl.toTime) || '',
            startDateTime: ctrl.getFromDateTime(true, ctrl.fromDate, ctrl.fromTime) || '',
            dateRangeField: ctrl.dateField,
            queryExpression: ctrl.model.definition.queryExpression,
            name: ctrl.model.definition.name,
            description: ctrl.model.definition.description,
            async: true,
            id: ctrl.lastAsyncReport.id,
          });

          $timeout(function () {
            const wHeight = screen.availHeight - 20;
            const wWidth = screen.availWidth - 20;

            window.open(
              '/app/reports/print',
              ctrl.model.definition.name,
              'height=' + wHeight + ',width=' + wWidth + ',left=10,scrollbars=yes,resizable=yes'
            );
            return;
          }, 10);
        }
      },

      showSavedModal: function () {
        this.showMessage('Report Saved', 'Report was successfully saved.');
      },

      showMessage: function (title: string, message: string) {
        if (message) {
          ctrl.showMessageModal = $uibModal.open({
            templateUrl: 'views/application/views/reports/create/modals/showMessage.tpl.html',
            size: 'md',
            controller: 'ReportsCreateShowMessageModalController',
            resolve: {
              currentTitle: () => {
                return title;
              },
              currentMessage: () => {
                return message;
              },
              safe: () => {
                return true;
              },
            },
          });
          // Invoked when modal completes with close(params)
          ctrl.showMessageModal.result.then(
            () => {},
            () => {}
          );
        }
      },

      addFilter: function () {
        if (ctrl.model.definition.queryExpression.findQueries == null) {
          ctrl.model.definition.queryExpression.findQueries = [];
        }

        ctrl.model.definition.queryExpression.findQueries.push({
          fieldName: null,
          operator: 'equals',
          fieldValue: null,
        });

        $timeout(function () {
          $('.filter-focus-last').focus();
        }, 10);
      },

      removeFilter: function (ndx) {
        ctrl.model.definition.queryExpression.findQueries.splice(ndx, 1);
      },

      findMetadataField: function (name: string) {
        let result: TODO | false = false;
        const fields = ctrl.model.collection.analyticsFieldMetadataList;

        for (let i = 0, ii = fields.length; i < ii; i++) {
          if (fields[i].name.toLowerCase() === name.toLowerCase()) {
            result = {
              index: i,
              field: fields[i],
            };
            break;
          }
        }

        return result;
      },

      findMetadataFieldsByType: function (type: unknown, prop) {
        let types: TODO[] = [];
        const result: TODO[] = [];

        const fields = ctrl.model.collection.analyticsFieldMetadataList;

        if (Array.isArray(type)) {
          types = type;
        } else if (typeof type === 'string') {
          types.push(type);
        }

        for (let i = 0, ii = fields.length; i < ii; i++) {
          for (let j = 0, jj = types.length; j < jj; j++) {
            if (fields[i].dataType.toLowerCase() === types[j].toLowerCase()) {
              if (Array.isArray(prop)) {
                const extract = {};
                for (let k = 0, kk = prop.length; k < kk; k++) {
                  if (fields[i].hasOwnProperty(prop[k])) {
                    extract[prop[k]] = fields[i][prop[k]];
                  }
                }
                result.push(extract);
              } else if (prop && fields[i].hasOwnProperty(prop)) {
                // Get only the property
                result.push(fields[i][prop]);
              } else {
                //Get the entire field
                result.push(fields[i]);
              }
              break;
            }
          }
        }

        return result;
      },

      addGroupBy: function () {
        if (ctrl.model.definition.queryExpression.groupFields == null) {
          ctrl.model.definition.queryExpression.groupFields = [];
        }

        ctrl.model.definition.queryExpression.groupFields.push({
          fieldName: null,
          groupFunction: '',
        });

        $timeout(function () {
          $('.groupby-focus-last').focus();
        }, 10);
      },

      removeGroupBy: function (ndx) {
        ctrl.model.definition.queryExpression.groupFields.splice(ndx, 1);
      },

      addSummarizeBy: function () {
        if (ctrl.model.definition.queryExpression.summaryFields == null) {
          ctrl.model.definition.queryExpression.summaryFields = [];
        }

        ctrl.model.definition.queryExpression.summaryFields.push({
          fieldName: null,
          summaryFunction: ctrl.summary.functions[0],
        });

        $timeout(function () {
          $('.summarizeby-focus-last').focus();
        }, 10);
      },

      removeSummarizeBy: function (ndx) {
        ctrl.model.definition.queryExpression.summaryFields.splice(ndx, 1);
      },

      addCount: function () {
        if (ctrl.model.definition.queryExpression.countFields == null) {
          ctrl.model.definition.queryExpression.countFields = [];
        }

        ctrl.model.definition.queryExpression.countFields.push({
          fieldName: null,
          countFunction: ctrl.count.functions[0],
        });

        $timeout(function () {
          $('.count-focus-last').focus();
        }, 10);
      },

      removeCount: function (ndx) {
        ctrl.model.definition.queryExpression.countFields.splice(ndx, 1);
      },

      enterEditMode: function (e) {
        e.stopPropagation();
        ctrl.nameEditMode = true;
      },
    },

    gridActions: {
      isDateField: function (name: LooseAutocomplete<'DATE'>) {
        let current;

        for (let i = 0; i < ctrl.model.collection.analyticsFieldMetadataList.length; i++) {
          current = ctrl.model.collection.analyticsFieldMetadataList[i];
          if (current.name == name) {
            return current.dataType == 'DATE';
          }
        }

        return false;
      },

      reorderColumns: function (column, originalPosition, newPosition) {
        if (column.field === ctrl.model.definition.queryExpression.findFields[originalPosition].fieldName) {
          ctrl.model.definition.queryExpression.findFields.splice(
            newPosition,
            0,
            ctrl.model.definition.queryExpression.findFields.splice(originalPosition, 1)[0]
          );
        }
      },

      reorderGroupedColumns: function (column, originalPosition, newPosition) {
        if (column.field === ctrl.model.definition.queryExpression.groupFields[originalPosition].fieldName) {
          ctrl.model.definition.queryExpression.findFields.splice(
            newPosition,
            0,
            ctrl.model.definition.queryExpression.findFields.splice(originalPosition, 1)[0]
          );
          ctrl.model.definition.queryExpression.groupFields.splice(
            newPosition,
            0,
            ctrl.model.definition.queryExpression.groupFields.splice(originalPosition, 1)[0]
          );
        }
      },

      reorderSummaryColumns: function (column, originalPosition, newPosition) {
        const ordered: TODO[] = [];

        for (let j = 0, jj = ctrl.model.definition.queryExpression.groupFields.length; j < jj; j++) {
          ordered.push(ctrl.model.definition.queryExpression.groupFields[j].fieldName);
        }

        for (let j = 0, jj = ctrl.model.definition.queryExpression.summaryFields.length; j < jj; j++) {
          ordered.push(ctrl.model.definition.queryExpression.summaryFields[j].fieldName);
        }

        for (let j = 0, jj = ctrl.model.definition.queryExpression.countFields.length; j < jj; j++) {
          ordered.push(ctrl.model.definition.queryExpression.countFields[j].fieldName);
        }

        for (let i = 0, ii = ctrl.model.definition.queryExpression.findFields.length; i < ii; i++) {
          for (let j = 0, jj = ordered.length; j < jj; j++) {
            if (ordered[j] === ctrl.model.definition.queryExpression.findFields[i].fieldName) {
              ctrl.model.definition.queryExpression.findFields.splice(
                j,
                0,
                ctrl.model.definition.queryExpression.findFields.splice(j, 1)[0]
              );
              break;
            }
          }
        }
      },

      addColumn: function (name: string) {
        let column;
        let groupField;
        const field = ReportsService.findMetadataField(name).field;

        if (!ctrl.fieldsPanel.findColumn(name)) {
          ctrl.gridData = [];

          column = {
            field: name,
            displayName: field.displayName,
          };

          if (field.dataType === 'DATE') {
            if (ctrl.isGroupingBy(name)) {
              // Need to look at group function before determining if it truly is a DATE type field
              groupField = ReportsService.findGroupField(name, ctrl.model.definition.queryExpression).field;

              if (groupField && groupField.groupFunction && groupField.groupFunction.toLowerCase() === 'date') {
                column.cellTemplate =
                  '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><span>{{ COL_FIELD | UTCDate:"' +
                  ctrl.dateTimeFormat +
                  '" }}</span></div>';
              }
            } else {
              column.cellTemplate =
                '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><span>{{ COL_FIELD | UTCDate:"' +
                ctrl.dateTimeFormat +
                '" }}</span></div>';
            }
          } else if (field.dataType === 'CURRENCY') {
            column.cellTemplate =
              '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><span>{{ COL_FIELD | currency }}</span></div>';
            column.type = 'number';
          }
          ctrl.grid.columns.push(column);
        }
      },

      removeColumn: function (name: string) {
        if (ctrl.fieldsPanel.findColumn(name)) {
          ctrl.gridData = [];

          for (let i = 0; i < ctrl.grid.columns.length; i++) {
            if (ctrl.grid.columns[i].field == name) {
              ctrl.grid.columns.splice(i, 1);
              break;
            }
          }
        }
      },
    },

    fieldsPanel: {
      find: function (name: string) {
        let result: TODO | false = false;

        if (!Array.isArray(ctrl.model.definition.queryExpression.findFields)) {
          ctrl.model.definition.queryExpression.findFields = [];
        }

        for (let i = 0; i < ctrl.model.definition.queryExpression.findFields.length; i++) {
          if (ctrl.model.definition.queryExpression.findFields[i].fieldName === name) {
            result = {
              index: i,
              field: ctrl.model.definition.queryExpression.findFields[i],
            };
            break;
          }
        }

        return result;
      },

      findColumn: function (field) {
        let result: TODO | false = false;

        for (let i = 0, ii = ctrl.grid.columns.length; i < ii; i++) {
          if (ctrl.grid.columns[i].field === field) {
            result = {
              index: i,
              column: ctrl.grid.columns[i],
            };
            break;
          }
        }

        return result;
      },

      toggleField: function (field, init) {
        let state = ctrl.fieldSelection[field.name];
        const found = this.find(field.name);

        if (!init) {
          state = !state;
        }
        ctrl.fieldSelection[field.name] = state;

        // Toggle state
        if (state) {
          // Toggle on if field does not already exist
          if (!found) {
            ctrl.model.definition.queryExpression.findFields.push({
              fieldName: field.name,
              include: true,
            });
            ctrl.gridActions.addColumn(field.name);
          }
        } else {
          // Toggle off if field exists
          if (found) {
            ctrl.model.definition.queryExpression.findFields.splice(found.index, 1);
            ctrl.gridActions.removeColumn(field.name);
          }
        }
      },

      updateFilterField: function (filter) {
        if (ctrl.isDateField(filter.fieldName) || ctrl.isNumericField(filter.fieldName)) {
          ctrl.fieldsPanel.setBetweenFilter(filter);
        } else if (ctrl.fieldsPanel.isBetweenOperator(filter.operator)) {
          filter.operator = this.getFilterOperators(filter.fieldName)[0];
        }
        filter.fieldValue = null;

        this.fetchFieldValues(filter);
      },

      updateFilterOperator: function (filter) {
        // if switching from between operator to single value operator, reset the value
        if (!ctrl.fieldsPanel.isBetweenOperator(filter.operator)) {
          if (filter.fieldValue) {
            if (filter.fieldValue.split(',').length > 1) {
              filter.fieldValue = null;
            }
          }
        } else {
          // if switching from any operator to between operator, set defaults
          if (ctrl.isDateField(filter.fieldName) || ctrl.isNumericField(filter.fieldName)) {
            ctrl.fieldsPanel.setBetweenFilter(filter);
          }
        }
      },

      //load filter values, or use the date range from the report
      setBetweenFilter: function (filter) {
        let fromDate;
        let toDate;
        let values;

        if (ctrl.isDateField(filter.fieldName)) {
          values = filter.fieldValue ? filter.fieldValue.split(',') : [];

          if (
            values.length > 1 &&
            !isNaN(CalendarService.parseDate(values[0]).getTime() && !isNaN(CalendarService.parseDate(values[1])))
          ) {
            fromDate = CalendarService.parseDate(values[0]);
            toDate = CalendarService.parseDate(values[1]);
          } else {
            fromDate = CalendarService.parseDate(ctrl.fromDate);
            toDate = CalendarService.parseDate(ctrl.toDate);
          }
          filter.fromDate = fromDate;
          filter.fromTime = $filter('date')(
            filter.fromDate,
            UserPreferencesService.getDateFormat('standardTime', 'hourFormat')
          );
          filter.toDate = toDate;
          filter.toTime = $filter('date')(
            filter.toDate,
            UserPreferencesService.getDateFormat('standardTime', 'hourFormat')
          );

          filter.start = ctrl.getFromDateTime(true, filter.fromDate, filter.fromTime);
          filter.end = ctrl.getToDateTime(true, filter.toDate, filter.toTime);

          if (!filter.fieldValue) {
            filter.fieldValue = [filter.start].concat([filter.end]).join();
          }
        } else if (ctrl.isNumericField(filter.fieldName)) {
          values = filter.fieldValue ? filter.fieldValue.split(',') : [];
          if (values.length > 1) {
            filter.start = parseInt(values[0], 10);
            filter.end = parseInt(values[0], 10);
          } else {
            filter.start = 0;
            filter.end = 0;
          }
          if (!filter.fieldValue) {
            filter.fieldValue = [filter.start].concat([filter.end]).join();
          }
        }
      },

      selectField: function (field) {
        const found = this.find(field.name);

        ctrl.fieldSelection[field.name] = true;

        if (!found) {
          ctrl.model.definition.queryExpression.findFields.push({
            fieldName: field.name,
            include: true,
          });
          ctrl.gridActions.addColumn(field.name);
        }
      },

      unselectField: function (field) {
        const found = this.find(field.name);

        ctrl.fieldSelection[field.name] = false;

        if (found) {
          ctrl.model.definition.queryExpression.findFields.splice(found.index, 1);
          ctrl.gridActions.removeColumn(field.name);
        }
      },

      clearFields: function () {
        for (let i = ctrl.model.definition.queryExpression.findFields.length - 1; i >= 0; i--) {
          const field = ctrl.model.definition.queryExpression.findFields.splice(i, 1);

          ctrl.gridActions.removeColumn(field[0].fieldName);
        }

        for (const name in ctrl.fieldSelection) {
          if (ctrl.fieldSelection.hasOwnProperty(name)) {
            ctrl.fieldSelection[name] = false;
          }
        }
      },

      getFieldTypes: function () {
        const fieldTypes: TODO[] = [];
        let prev = '';
        let current = '';

        for (let i = 0; i < ctrl.model.collection.analyticsFieldMetadataList.length; i++) {
          current = ctrl.model.collection.analyticsFieldMetadataList[i].objectName;
          if (prev != current) {
            prev = current;
            fieldTypes.push(current);
          }
        }

        return fieldTypes;
      },

      getFieldList: function (type) {
        const fields: TODO[] = [];

        for (let i = 0; i < ctrl.model.collection.analyticsFieldMetadataList.length; i++) {
          const current = ctrl.model.collection.analyticsFieldMetadataList[i];

          if (current.objectName == type) {
            fields.push(current);
          }
        }

        return fields;
      },

      getFields: function () {
        const groups: TODO[] = [];
        const types = this.getFieldTypes();

        for (let i = 0, ii = types.length; i < ii; i++) {
          groups.push({
            name: types[i],
            fields: this.getFieldList(types[i]),
            selected: ctrl.fieldSelection,
          });
        }

        return groups;
      },

      showFields: function (type) {
        const fieldType = ctrl.showFieldTypes[type];
        let show = true;

        if (fieldType != null) {
          show = fieldType;
        }

        return show;
      },

      toggleFieldTypeVisible: function (field) {
        let b = ctrl.showFieldTypes[field];

        if (b == null) {
          b = true;
        }

        ctrl.showFieldTypes[field] = !b;
      },

      setFieldSelections: function () {
        let current: TODO;
        let summaryFields: TODO[] = [];

        ctrl.fieldSelection = {};
        ctrl.fieldNames = [];
        ctrl.dateFieldNames = [];
        ctrl.numericFieldNames = [];
        ctrl.fieldValues = {};

        const currencyFields = ctrl.actions.findMetadataFieldsByType('currency', ['name', 'displayName']);
        const decimalFields = ctrl.actions.findMetadataFieldsByType('decimal', ['name', 'displayName']);
        const integerFields = ctrl.actions.findMetadataFieldsByType('integer', ['name', 'displayName']);

        if (currencyFields) {
          summaryFields = summaryFields.concat(currencyFields);
        }
        if (decimalFields) {
          summaryFields = summaryFields.concat(decimalFields);
        }
        if (integerFields) {
          summaryFields = summaryFields.concat(integerFields);
        }

        ctrl.summaryFieldNames = summaryFields;

        for (let i = 0; i < ctrl.model.collection.analyticsFieldMetadataList.length; i++) {
          current = ctrl.model.collection.analyticsFieldMetadataList[i];
          ctrl.fieldSelection[current.name] = false;
          ctrl.fieldNames.push({
            name: current.name,
            displayName: current.displayName,
          });
          if (current.dataType == 'DATE') {
            ctrl.dateFieldNames.push({
              name: current.name,
              displayName: current.displayName,
            });
            if (current.defaultDateField) {
              ctrl.dateField = current.name;
            }
          }
          if (current.dataType == 'INTEGER') {
            ctrl.numericFieldNames.push({
              name: current.name,
              displayName: current.displayName,
            });
          }
          ctrl.fieldValues[current.name] = ctrl.fieldsPanel.getFieldValues(current.name);
        }

        if (ctrl.model.definition.queryExpression.findFields != null) {
          for (let i = 0; i < ctrl.model.definition.queryExpression.findFields.length; i++) {
            current = ctrl.model.definition.queryExpression.findFields[i];
            ctrl.fieldSelection[current.fieldName] = true;
            ctrl.gridActions.addColumn(current.fieldName);
          }
        }

        //ctrl.grid.sortInfo.fields = [];
        //ctrl.grid.sortInfo.directions = [];

        //if (ctrl.model.definition.queryExpression.sortFields != null) {
        //  for (let i=0,ii=ctrl.model.definition.queryExpression.sortFields.length;i<ii;i++) {
        //    if (ctrl.fieldsPanel.findColumn(ctrl.model.definition.queryExpression.sortFields[i].fieldName)) {
        //      ctrl.grid.sortInfo.fields.push(ctrl.model.definition.queryExpression.sortFields[i].fieldName);
        //      ctrl.grid.sortInfo.directions.push((ctrl.model.definition.queryExpression.sortFields[i].ascending) ? 'asc' : 'desc');
        //    }
        //  }
        //}

        if (!ctrl.model.definition.customReport) {
          if (!ctrl.hasColumns()) {
            // No fields selected force a selection
            ctrl.showColumns(true);
          } else {
            if (!PermissionsService.check(['REPORTS_EXECUTE', 'REPORTS_OWNER_EXECUTE'])) {
              $scope.$emit('Permissions::error');
            }
          }
        }
      },

      fieldSelected: function (name: string) {
        const selected = ctrl.fieldSelection[name];

        if (selected != null) {
          return selected;
        }

        return false;
      },

      getFieldValues: function (name: string, extractField?: string) {
        let result: TODO | false = false;
        const meta = ctrl.actions.findMetadataField(name);

        if (meta && Array.isArray(meta.field.values)) {
          if (extractField) {
            result = meta.field.values.map(function (item) {
              return item[extractField] ? item[extractField] : null;
            });
          } else {
            result = meta.field.values;
          }
        }

        return result;
      },

      getFieldValuesForUsers: function (name: string) {
        let result: TODO | false = false;
        const meta = ctrl.actions.findMetadataField(name);

        if (meta && Array.isArray(meta.field.values)) {
          result = meta.field.values.map(function (item) {
            return item['email'] ? item['email'] : item['userName'] ? item['userName'] : null;
          });
        }

        return result;
      },

      fetchFieldValues: function (field) {
        const props = HelpersService.getPaginator();

        const error = (response) => {};
        const success = (response) => {
          ctrl.model.collection.analyticsFieldMetadataList[
            ctrl.actions.findMetadataField(field.fieldName).index
          ].values = response.data.payload.list;
          ctrl.fieldValues[field.fieldName] = ctrl.fieldsPanel.getFieldValues(field.fieldName, 'name');
        };

        switch (field.fieldName) {
          case 'PaymentMethod':
            // This is an ENUM already populated no need for async call
            break;
          case 'TenantGroup':
            break;
          case 'EventTemplateName':
            ctrl.setTypeahead(field);
            break;
          case 'TicketType':
            props.types = 'all';
            props.inactive = true;
            ApiService.price.types.list(props).then(success).catch(error);
            break;
          case 'AddOn':
            ApiService.inventory.list(props).then(success).catch(error);
            break;
          case 'TransactionUserLogin':
            ApiService.userProxy
              .list(props)
              .then(function (response) {
                const index = ctrl.actions.findMetadataField(field.fieldName).index;
                ctrl.model.collection.analyticsFieldMetadataList[index].values = $filter('orderBy')(
                  response.data.payload.list,
                  'email'
                );
                ctrl.fieldValues[field.fieldName] = ctrl.fieldsPanel.getFieldValuesForUsers(field.fieldName);
              })
              .catch(error);
            break;
          // case 'Email':
          //   ApiService.userProxy.list(props).then(function(response) {
          //     ctrl.model.collection.analyticsFieldMetadataList[ctrl.actions.findMetadataField(field.fieldName).index].values = response.data.payload.list;
          //     ctrl.fieldValues[field.fieldName] = ctrl.fieldsPanel.getFieldValues(field.fieldName, (field.fieldName === 'Email') ? 'email' : 'userName');
          //   }, error);
          //   break;
        }
      },

      isMultiSelectOperator: function (operator) {
        return operator.indexOf('contain') >= 0;
      },

      isMultiSelectField: function (fieldName) {
        let result = false;

        switch (fieldName) {
          case 'PaymentMethod':
          /* falls through */
          case 'TicketType':
          /* falls through */
          case 'AddOn':
          /* falls through */
          case 'TransactionUserLogin':
          /* falls through */
          case 'CreditCardBrand':
          /* falls through */
          case 'SaleChannel':
          /* falls through */
          case 'PaymentStatus':
          /* falls through */
          case 'TransactionType':
          /* falls through */
          case 'TenantGroup':
          /* falls through */
          // case 'Email':
          /* falls through */
          case 'OrderItemType':
          /* falls through */
          case 'TransactionLifecycleAction':
            result = true;
            break;
        }

        return result;
      },

      isTextField: function (fieldName, operator) {
        let result = false;

        switch (fieldName) {
          case 'Email':
            result = true;
            break;
        }

        return operator.indexOf('like') >= 0 && result;
      },

      isExistOperator: function (operator) {
        return operator && operator.indexOf('exist') >= 0;
      },

      isTypeaheadField: function (fieldName) {
        let result = false;

        switch (fieldName) {
          case 'EventTemplateName':
            result = true;
            break;
        }

        return result;
      },

      isBetweenOperator: function (operator) {
        return operator && operator.indexOf('between') >= 0;
      },

      getFilterOperators: function (fieldName) {
        const filterOperators = [
          'equals',
          'not equal to',
          'less than',
          'less or equal',
          'greater than',
          'greater or equal',
          'contains',
          'does not contain',
          'like',
          'exists',
          'does not exist',
        ];

        if (ctrl.isDateField(fieldName) || ctrl.isNumericField(fieldName)) {
          filterOperators.push('between');
        }

        return filterOperators;
      },
    },
    summary: {
      functions: ['Sum', 'Average', 'Maximum', 'Minimum', 'Single'],

      getSummaryFunctions: function () {
        return ['Sum', 'Average', 'Maximum', 'Minimum', 'Single'];
      },
    },
    group: {
      functions: ['Date', 'Day', 'Week', 'Month', 'Year', 'DayMonthYear'],

      getGroupByFunctions: function () {
        return ['Date', 'Day', 'Week', 'Month', 'Year', 'DayMonthYear'];
      },
    },
    count: {
      functions: ['Count', 'Distinct Count'],

      getCountFunctions: function () {
        return ['Count', 'Distinct Count'];
      },
    },
  };

  $scope.reportsCreate = ctrl;
  ctrl.init();
}

export const ReportsCreateControllerModule = angular
  .module('acme.view.application.reports.create.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.calendar',
    'acme.common.service.validate',
    'acme.common.service.helpers',
    'acme.common.service.reports',
    'acme.common.service.permissions',
    'acme.common.service.themesHelper',
    'acme.common.factory.notice',
    'acme.common.factory.gridState',
    'acme.common.service.userPreferences',
    'acme.common.service.reportingApi',
    'acme.common.directive.integer',
    'acme.view.application.reports.removeModal.controllers',
    ReportsCreateShowColumnsModalControllerModule,
    'acme.view.application.reports.create.showMessageModal.controllers',
    'acme.view.application.reports.create.showGroupsModal.controllers',
    'acme.view.application.reports.create.showMultiselectModal.controllers',
    'acme.view.application.reports.create.modals.selectTime.controllers',
    UTCDateFilterModule,
    ReportsDatePickerControllerModule,
  ])
  .controller('ReportsCreateController', ReportsCreateController).name;
